import script from "./AccessFunnelIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccessFunnelIndex.vue?vue&type=script&setup=true&lang=ts"

import "./AccessFunnelIndex.vue?vue&type=style&index=0&id=5bcf290c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bcf290c"]])

export default __exports__